<template>
  <div>
    <vx-card>
     <vs-tabs :value="activeTab">
      <vs-tab :label="$t('newsletter.workflow.data_basic')">
        <form-basic :id="id"></form-basic>
      </vs-tab>
      <vs-tab v-if="id" :label="$t('newsletter.workflow.timeline')">
        <form-timeline :id="id"></form-timeline>
      </vs-tab>
      <vs-tab v-if="id" :label="$t('newsletter.workflow.destination')">
        <form-destination :id="id"></form-destination>
      </vs-tab>
    </vs-tabs>
  </vx-card>
  </div>
</template>

<script>

import standard from '@/services/standard'
import { isAdmin } from '@/util/Util'

import FormBasic from './FormBasic.vue'
import FormTimeline from './FormTimeline.vue'
import FormDestination from './FormDestination.vue'

import NewsletterWorkflowService from '@/services/api/NewsletterWorkflowService'

export default {

  directives: {

  },
  components: {
    FormBasic,
    FormTimeline,
    FormDestination,
  },
  props: {
    id: {
      default: null,
      type: Number
    }
  },

  data: () => ({
    service: null,
    activeTab: 0,
  }),
  computed: {
    validateForm() {
      return !this.isEmpty(this.model.name)
    },
  },
  watch: {
    '$route.query.tab'(newTab) {
      if (this.id && newTab !== undefined) {
        setTimeout(() => {
          this.activeTab = parseInt(newTab, 10)
        }, 100)
      }
    }
  },
  beforeMount() {
    this.service = NewsletterWorkflowService.build(this.$vs)
  },
  mounted() {
    if (this.id) {
      // Define a aba ativa com base na query string (somente se tiver id)
      const tabFromQuery = this.$route.query.tab
      if (tabFromQuery !== undefined) {
        // Usa setTimeout para garantir que as abas condicionais foram renderizadas
        setTimeout(() => {
          this.activeTab = parseInt(tabFromQuery, 10)
        }, 100)
      }
      //this.loadData(this.id)
    }
  },

  methods: {
    goBack() {
      this.$router.push('/newsletter_workflows')
    },
    isAdmin() {
      return isAdmin()
    },
    isEdit() {
      return !_.isNil(this.id)
    },
  }
}
</script>

<style>

</style>
